<script lang="ts">
  import { onMount } from 'svelte';
  import { trackEvent } from '../../util/snowplow';
  import { clientState } from '../../util/stores';
  import Tooltip from '../Tooltip.svelte';
  let hasClicked = false;

  onMount(() => {
    trackEvent(
      { action: 'state:artist-before-poll', label: $clientState.title },
      $clientState.id
    );
  });
</script>

<button
  class="vote-button"
  on:click={() => {
    hasClicked = !hasClicked;
    trackEvent({ action: 'click:submit-votes-disabled' }, $clientState.id);
  }}
  title="Vent til avstemningen er åpen"
  disabled={hasClicked}
>
  {#if hasClicked}
    <Tooltip carretPosition={50}>
      Du kan stemme når avstemningen åpner. Følg med på direktesendingen.
    </Tooltip>
  {/if}
  <div class="vote-button-bg" />
  <div class="vote-button-inner">stem</div>
</button>

<style>
  .vote-button {
    margin-top: -4.75rem;
    position: relative;
    padding: 0;
    background-color: transparent;
    z-index: 1;
    width: 100%;
  }

  .vote-button-inner {
    display: block;
    text-transform: uppercase;
    font-size: 1.5625rem;
    line-height: 2;
    font-weight: 890;
    letter-spacing: 0.2em;
    padding: 0.5635rem;
    color: rgba(255, 255, 255, 0.7);
    background: linear-gradient(181.84deg, #0d0b20 1.55%, #1a163e 187.27%);
    box-shadow: 0px 7px 18px rgba(0, 0, 0, 0.8);
    margin: 0.5rem;
  }

  .vote-button-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background: linear-gradient(181.84deg, #0d0b20 1.55%, #1a163e 187.27%);
    box-shadow:
      0px 4px 4px rgba(0, 0, 0, 0.25),
      0px 6.25417px 15.8588px rgba(0, 0, 0, 0.92),
      0px 3.50603px 8.8903px rgba(255, 0, 88, 0.275),
      0px 1.86203px 4.72157px rgba(255, 0, 88, 0.222141),
      0px 0.774832px 21px #6b0081;
    opacity: 0.75;
  }
</style>
